/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Grade_Adjusted_Pace_Friendly_NameInputs */

const en_exp_grade_adjusted_pace_friendly_name = /** @type {(inputs: Exp_Grade_Adjusted_Pace_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade Adjusted Pace`)
};

const de_exp_grade_adjusted_pace_friendly_name = /** @type {(inputs: Exp_Grade_Adjusted_Pace_Friendly_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steigungsbereinigtes Tempo`)
};

/**
* | output |
* | --- |
* | "Grade Adjusted Pace" |
*
* @param {Exp_Grade_Adjusted_Pace_Friendly_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_grade_adjusted_pace_friendly_name = /** @type {((inputs?: Exp_Grade_Adjusted_Pace_Friendly_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Grade_Adjusted_Pace_Friendly_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_grade_adjusted_pace_friendly_name(inputs)
	return de_exp_grade_adjusted_pace_friendly_name(inputs)
});